import React from 'react';
import { Link } from "react-router-dom";
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';
import { LeftOutlined } from '@ant-design/icons';
import { Row, Col, Button, Modal, Form, Input } from 'antd';


class Content3 extends React.PureComponent {
  getDelay = (e, b) => (e % b) * 100 + Math.floor(e / b) * 100 + b * 100;

  state = {
    visible: false
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };


  layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  validateMessages = {
    required: '${label} را وارد کنید!',
  };


  render() {
    const { ...props } = this.props;
    const { dataSource, isMobile } = props;
    delete props.dataSource;
    delete props.isMobile;
    let clearFloatNum = 0;
    const children = dataSource.block.children.map((item, i) => {
      const childObj = item.children;
      const delay = isMobile ? i * 50 : this.getDelay(i, 24 / item.md);
      const liAnim = {
        opacity: 0,
        type: 'from',
        ease: 'easeOutQuad',
        delay,
      };
      const childrenAnim = { ...liAnim, x: '+=10', delay: delay + 100 };
      clearFloatNum += item.md;
      clearFloatNum = clearFloatNum > 24 ? 0 : clearFloatNum;
      return (
        <TweenOne
          component={Col}
          animation={liAnim}
          key={item.name}
          {...item}
          componentProps={{ md: item.md, xs: item.xs }}
          className={
            !clearFloatNum
              ? `${item.className || ''} clear-both`.trim()
              : item.className
          }
        >
          <TweenOne
            animation={{
              x: '-=10',
              opacity: 0,
              type: 'from',
              ease: 'easeOutQuad',
            }}
            key="img"
            {...childObj.icon}
          >
            <img src={childObj.icon.children} width="100%" alt="img" />
          </TweenOne>
          <div {...childObj.textWrapper}>
            <TweenOne
              key="h2"
              animation={childrenAnim}
              component="h2"
              {...childObj.title}
            >
              {childObj.title.children}
            </TweenOne>
            <TweenOne
              key="p"
              animation={{ ...childrenAnim, delay: delay + 200 }}
              component="div"
              {...childObj.content}
            >
              {childObj.content.children}
            </TweenOne>
          </div>
        </TweenOne>
      );
    });
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </div>
          <OverPack {...dataSource.OverPack}>
            <QueueAnim key="u" type="bottom">
              <Row key="row" {...dataSource.block}>
                {children}
              </Row>
            </QueueAnim>
            <div className="actions-box" style={{ marginTop: 20 }}>
              <Button onClick={this.showModal} className="ant-btn bold-btn">
                دریافت اکانت نمونه
              </Button>
              {/* 
              <Link href="#" to="#" className="ant-btn bold-btn">
                دریافت اکانت نمونه
              </Link> */}
              <Link href="/school-app" to="/school-app" className="my-link">
                اطلاعات بیشتر
                <LeftOutlined />
              </Link>
            </div>
          </OverPack>
        </div>

        <Modal title="وارد کردن اطلاعات" visible={this.state.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
          <div>
            اطلاعات خود را وارد کنید تا همکاران ما برای راهنمایی بیشتر در اسرع وقت با شماس بگیرند.
          </div>

          <div className="ant-row ant-row-rtl" style={{marginTop:20}}>
            <div className="ant-col ant-col-xs-24 ant-col-rtl14">
              <Form {...this.layout} name="nest-messages" validateMessages={this.validateMessages}>
                <Form.Item name={['user', 'name']} label="نام و نام خانوادگی" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>

                <Form.Item name={['user', 'phone']} label="شماره تماس" rules={[{ required: true, min: 0, max: 11 }]}>
                  <Input />
                </Form.Item>
              </Form>
            </div>
          </div>

        </Modal>

      </div>
    );
  }
}

export default Content3;
